import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles/QuizFormModal.module.css";
import {
  Accordion,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  FormControl,
  InputGroup,
  Modal,
  Nav,
  Row,
  Tab,
  useAccordionButton,
} from "react-bootstrap";
import clsx from "clsx";
import { useFormik } from "formik";
import { ReactSortable } from "react-sortablejs";
import { LectureItem } from "@components/SectionItem/LectureItem";
import { ListOptionQuiz } from "./ListOptionQuiz";
import { AnswerTextQuiz } from "./AnswerTextQuiz";
import { QuestionItem } from "./QuestionItem";
import { QuestionFormModal } from "./QuestionFormModal";
import * as Yup from "yup";

import { v4 as uuidv4 } from "uuid";
import { InputField, TextArea } from "@components/Input";

const QuizFormModal = ({ children, onSubmit, initialValues }) => {
  // state
  // variables

  // logics before hooks
  const validationSchema = Yup.object().shape({
    questions: Yup.array()
      .compact((val) => val.isDeleted == true)
      .min(1, "You must have at least 1 question"),
    title: Yup.string()
      .required("Quiz title is required")
      .max(100, "Quiz title require maximum of 100 characters"),
    description: Yup.string().required("Quiz description is required"),

    isGradable: Yup.boolean(),
    isShowTime: Yup.boolean(),
    timeLimit: Yup.number().when("isShowTime", {
      is: true,
      then: Yup.number()
        .min(0, "Time must be equal or greater than 0")
        .required("Require"),
    }),
    passingScore: Yup.number()
      .min(0, "Passing score must be equal or greater than 0")
      .max(100, "100 is maximum")
      .required("Require"),
    questionsLimit: Yup.number().min(
      0,
      "Questions limit score must be equal or greater than 0"
    ),
  });
  // hooks
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
      handleClose();
    },
  });
  // logics
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    formik.resetForm();
    setShow(false);
  };

  const handleAddQuestion = (values) => {
    console.log(values);
    const newQuestion = [
      ...formik.values.questions,
      { ...values, id: uuidv4(), isNew: true },
    ];
    formik.setFieldValue("questions", newQuestion);
  };

  const handleEditQuestion = (id, values) => {
    const questions = [...formik.values.questions];
    const questionIndex = questions.findIndex((question) => question.id == id);
    console.log(questionIndex);
    questions.splice(questionIndex, 1, values);
    formik.setFieldValue("questions", questions);
  };

  console.log(formik.values.questions);

  const handleDeleteQuestion = (id) => {
    const questions = [...formik.values.questions];
    const questionIndex = questions.findIndex((question) => question.id == id);
    const newQuestion = { ...questions[questionIndex], isDeleted: true };
    // questions[questionIndex].isDeleted = true;
    questions.splice(questionIndex, 1, newQuestion);
    formik.setFieldValue("questions", questions);
  };
  // UI partials
  const [tab, setTab] = useState("basic");

  // effects
  useEffect(() => {
    formik.setValues(initialValues);
  }, [initialValues]);

  useEffect(() => {
    if (formik.values.title && formik.values.description) {
      if (
        // formik.touched.videoLecture &&
        formik.errors.questions &&
        tab != "question"
      ) {
        setTab("question");
        // formik.setErrors({});
      } else if (formik.errors.settings) {
        setTab("setting");
      }
    } else {
      setTab("basic");
    }
  }, [formik.submitCount]);
  // render
  const totalQuestion = formik.values.questions?.filter(
    (question) => !question.isDeleted
  ).length;
  return (
    <>
      <span onClick={handleShow}>{children}</span>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Add Quiz</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={clsx(styles.tabContainer, "container")}>
            <Form>
              <Tab.Container
                defaultActiveKey="basic"
                onSelect={(key) => setTab(key)}
                activeKey={tab}
              >
                <Nav variant="pills" className="mt-3 mb-4 row m-0 p-0">
                  <Nav.Item className="col-12 col-lg-4 p-0">
                    <Nav.Link eventKey="basic">
                      <i className="bi bi-file-earmark-text-fill mr-2"></i>
                      Basic
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col-12 col-lg-4 p-0">
                    <Nav.Link eventKey="question">
                      <i className="bi bi-question-circle-fill mr-2"></i>
                      Questions
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="col-12 col-lg-4 p-0">
                    <Nav.Link eventKey="setting">
                      <i className="bi bi-gear-fill mr-2"></i>Setting
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="basic">
                    <div className="mb-3">
                      <InputField
                        name={"title"}
                        type={"text"}
                        label={"Quiz Title*"}
                        placeholder="Quiz title here"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        autoComplete="off"
                        touchedValue={formik.touched.title}
                        errorsValue={formik.errors.title}
                      />
                    </div>

                    <div className="mb-3">
                      <TextArea
                        label="Description*"
                        type={"textarea"}
                        name="description"
                        placeholder={"Description here..."}
                        rows={5}
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        autoComplete="off"
                        touchedValue={formik.touched.description}
                        errorsValue={formik.errors.description}
                      />
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="question">
                    <QuestionFormModal onSubmit={handleAddQuestion}>
                      <Button className="w-100 py-2">
                        <i className="bi bi-plus-square"></i> Add Question
                      </Button>
                    </QuestionFormModal>
                    {formik.errors.questions && formik.touched.questions && (
                      <p className="text-danger text-center mt-3">
                        {formik.errors.questions}
                      </p>
                    )}
                    <div className="mt-4">
                      {/* <ReactSortable
                        list={formik.values.questions}
                        setList={() => {}}
                      > */}
                      {formik.values.questions.map((item, index) => {
                        return (
                          <QuestionItem
                            key={index}
                            title={item.title}
                            question={item}
                            onDelete={() => handleDeleteQuestion(item.id)}
                            onEdit={(values) =>
                              handleEditQuestion(item.id, values)
                            }
                          />
                        );
                      })}
                      {/* </ReactSortable> */}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="setting">
                    <div className="">
                      {/* <div className="grade mb-4">
                        <h6>Gradable</h6>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label="Quiz Gradable"
                          name="isGradable"
                          value={formik.values.isGradable}
                          onChange={formik.handleChange}
                          checked={formik.values.isGradable}
                        />
                        <p>
                          If this quiz test affect on the students grading
                          system for this course.
                        </p>
                      </div> */}
                      <div className="grade mb-4">
                        <h6>Set a time limit for quiz</h6>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label="Time limited"
                          name="isShowTime"
                          value={formik.values.isShowTime}
                          onChange={formik.handleChange}
                          checked={formik.values.isShowTime}
                        />
                        <p>
                          By enabling this option, quiz taker will set limit
                          time and show remaining time during attempt.
                        </p>
                      </div>

                      <div className="d-flex gap-3 justify-content-between">
                        {formik.values.isShowTime && (
                          <div className="time flex-grow-1">
                            <h6>Time Limit</h6>
                            <InputGroup className="">
                              <Form.Control
                                aria-label="Default"
                                aria-describedby="inputGroup-sizing-default"
                                type="number"
                                name="timeLimit"
                                value={formik.values.timeLimit}
                                onChange={formik.handleChange}
                                isInvalid={formik.errors.timeLimit}
                              />
                              <InputGroup.Text id="inputGroup-sizing-default">
                                Minutes
                              </InputGroup.Text>
                              <Form.Control.Feedback
                                type="invalid"
                                className="text-left"
                              >
                                {formik.errors.timeLimit}
                              </Form.Control.Feedback>
                            </InputGroup>
                            <p>Set zero to disable time limit.</p>
                          </div>
                        )}
                        {/* {formik.values.isGradable && ( */}
                        <div className="time flex-grow-1 ">
                          <h6>Passing Score(%)*</h6>

                          <Form.Control
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            type="number"
                            name="passingScore"
                            value={formik.values.passingScore}
                            onChange={formik.handleChange}
                            isInvalid={formik.errors.passingScore}
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="text-left"
                          >
                            {formik.errors.passingScore}
                          </Form.Control.Feedback>
                          <p>
                            Student have to collect this score in percent for
                            the pass this quiz.
                          </p>
                        </div>
                        {/* )} */}
                        <div className="time flex-grow-1 ">
                          <h6>
                            Questions Limit* (Total question: {totalQuestion})
                          </h6>

                          <Form.Control
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                            type="number"
                            name="questionsLimit"
                            value={formik.values.questionsLimit}
                            onChange={(event) => {
                              if (event.target.value > totalQuestion) {
                                formik.setFieldError(
                                  "questionsLimit",
                                  `The maximum is ${totalQuestion}`
                                );
                              } else {
                                formik.handleChange(event);
                              }
                            }}
                            isInvalid={formik.errors.questionsLimit}
                            max={formik.values.questions.length}
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="text-left"
                          >
                            {formik.errors.questionsLimit}
                          </Form.Control.Feedback>
                          <p>
                            The number of questions student have to answer in
                            this quiz.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={formik.handleSubmit}>Save</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

/* required: display name */
QuizFormModal.displayName = "QuizFormModal";

/* required: props types */
QuizFormModal.propTypes = {};

/* required: default props */
QuizFormModal.defaultProps = {
  initialValues: {
    title: "",
    description: "",
    questions: [],
    isShowTime: true,
    timeLimit: 0,
    passingScore: 0,
    questionsLimit: 0,
  },
};

export { QuizFormModal };
